/*
 * GameSummaryScreen
 * ==========
 */

import StatsScreen from '../ui/StatsScreen'

export default class GameSummaryScreen extends StatsScreen {

    constructor(game, screens) {
        super(game, 'gameOver');
        window.gameOver = this;

        this.screens = screens;
        this.bg = this.addSprite('bg', 'uiScreens', 'uiGameSummaryPanel.png');

        this.statsOffsetY = 0;
        this.initSummaryStats();

        this.params = {
            'bg': [0, 0],
            'title': [1, -146],
            'yourScore': [0, -103],
            'yourScoreValue': [0, -69],
            'continue': [2, 141]
        };

        this.title = this.addText2('title', 'blue', 'GAME OVER', 30);
        this.yourScore = this.addText2('yourScore', 'white', 'Total Score', 20);
        this.yourScoreValue = this.addText2('yourScoreValue', 'white', '3,136', 34);
        this.continue = this.addTextButton2('continue', 'uiButtonContinue', 'Continue', this.continueClicked);
        this.setInputForAllButtons(false);
    }

    continueClicked(that) {
        // console.log('Continue')
        that.setInputForAllButtons(false);
        that.forceOutForAllButtons();

        if (GS.goalReached) {
            that.screens.showScreen('levelStart')
        } else {
            ARK_game_arena_connector.changeScore(GS.score, 'Game Complete');
            ARK_game_arena_connector.fireEventToArena('game_end');
            GS.setupLevel(1);
            setTimeout(function () {
                that.screens.showScreen('gameStart')
            }, 5000)
        }
    }

    onShowStarted() {
        this.updateView();
        super.onShowStarted();

        if (GS.game.device.desktop) { ARK_game_arena_connector.fireEventToArena('pause_ready'); }
        ARK_game_arena_connector.fireEventToArena('event_change');
        _gameGATracker('send', 'event', 'Level Complete', GS.level, GS.levelScore)

        if (GS.lines !== 20 && GS.goalReached) { AUDIO.playSound('success'); }
        else if (!GS.goalReached) { AUDIO.playSound('gameOver'); }
    }

    updateView() {
        if (GS.goalReached) {
            this.title.setText('LEVEL COMPLETED');
            this.continue.txt.setText('Continue');

            this.bestWordVal.setText((GS.bestWordLevel).toUpperCase().substring(0, 15));
            this.bestWordScoreVal.setText(GS.bestWordScoreLevel + '')
        } else {
            this.title.setText('GAME OVER');
            this.continue.txt.setText('Play Again');

            this.bestWordVal.setText((GS.bestWord).toUpperCase().substring(0, 15));
            this.bestWordScoreVal.setText(GS.bestWordScore + '');

            _gameGATracker('send', 'event', 'Game Over', GS.level, GS.score)
        }

        this.yourScoreValue.setText(GS.score + '');
        this.lastLevelScoreVal.setText(GS.levelScore + '');
        this.highestLevelVal.setText(GS.level + '');
        this.linesClearedVal.setText(GS.lines + '')
    }
}
